import React, { useEffect, useState, useRef } from 'react';
import "../engagementmodels/engagement.css"
import AOS from 'aos';
import 'aos/dist/aos.css'; // Import AOS styles


function Engagement() {

    useEffect(() => {
        AOS.init(); // Initialize AOS
    }, []);
    const [toogle, setToogle] = useState(1);
    const tabRef = useRef([]);
    const [indicatorStyle, setIndicatorStyle] = useState({});

    const toogleTab = (index) => {
        setToogle(index);
    };

    useEffect(() => {
        // Update tab indicator position and width based on the active tab
        if (tabRef.current[toogle]) {
            const activeTabElement = tabRef.current[toogle];
            setIndicatorStyle({
                width: `${activeTabElement.offsetWidth}px`,
                left: `${activeTabElement.offsetLeft}px`
            });
        } 
    }, [toogle]);
    return (
        <section className='engagement-main'>
            <div className="engagement-inner">
                <div className="A-title" data-aos="fade-up-left">
                    <span>Engagment models</span>
                    <h1>Flexible engagement models await!</h1>
                    <p className='title-text'>Discover our adaptable engagement models designed to seamlessly align with your needs, ensuring a collaborative approach that fosters innovation and success. Your vision drives our flexible partnership opportunities.</p>
                </div>
                <div className="eng-right" data-aos="fade-up-right"> 
                    <div className="eng-tabs">
                        <button
                            className={toogle === 1 ? 'engtab engactive-tab' : 'engtab'}
                            onClick={() => toogleTab(1)}
                            ref={(el) => (tabRef.current[1] = el)}
                        >
                            Staff Augmentation
                        </button>
                        <button
                            className={toogle === 2 ? 'engtab engactive-tab' : 'engtab'}
                            onClick={() => toogleTab(2)}
                            ref={(el) => (tabRef.current[2] = el)}
                        >
                            Dedicated Aigle Team
                        </button>
                        <button
                            className={toogle === 3 ? 'engtab engactive-tab' : 'engtab'}
                            onClick={() => toogleTab(3)}
                            ref={(el) => (tabRef.current[3] = el)}
                        >
                            Fixed Scope
                        </button>
                        {/* Tab indicator */}
                        <div
                            className="eng-tab-indicator"
                            style={indicatorStyle}
                        />
                    </div>

                    <div className={toogle === 1 ? 'eng-content active-eng-content' : 'eng-content'}>
                        <li className='engtitle'>Staff Augmentation</li>
                        <p className='engtext'>We provide additional profiles to enhance your team and fill in missing competencies. Our colleagues seamlessly integrate with your team and workflow.</p>
                        <ul className='eng-staff'>
                            <li>Developers</li>
                            <li>Designers</li>
                            <li>QA</li>
                            <li>DevOps</li>
                        </ul>
                        <div className="eng-specs">
                            <div className="e-sp1">
                                <p>Duration</p>
                                <strong>Mid - Long</strong>
                            </div>
                            <div className="e-sp1">
                                <p>Flexibility</p>
                                <strong>High</strong>
                            </div>
                            <div className="e-sp1">
                                <p>Engagement model</p>
                                <strong>Time & Material</strong>
                            </div>
                        </div>
                    </div>
                    <div className={toogle === 2 ? 'eng-content active-eng-content' : 'eng-content'}>
                        <li className='engtitle'>Dedicated Agile Team</li>
                        <p className='engtext'>We are enhancing your tech capabilities with our tech team, bringing in extra expertise to speed up project development and guarantee successful outcomes.</p>
                        <ul className='eng-staff'>
                            <li>Developers</li>
                            <li>Designers</li>
                            <li>QA</li>
                            <li>DevOps</li>
                        </ul>
                        <div className="eng-specs">
                            <div className="e-sp1">
                                <p>Duration</p>
                                <strong>Mid - Long</strong>
                            </div>
                            <div className="e-sp1">
                                <p>Flexibility</p>
                                <strong>High</strong>
                            </div>
                            <div className="e-sp1">
                                <p>Engagement model</p>
                                <strong>Time & Material</strong>
                            </div>
                        </div>
                    </div>
                    <div className={toogle === 3 ? 'eng-content active-eng-content' : 'eng-content'}>
                        <li className='engtitle'>Set Objective</li>
                        <p className='engtext'>We focus on achieving the goals set for your projects. We strategically allocate resources to ensure successful outcomes within the defined parameters.</p>
                        <ul className='eng-staff'>
                            <li>Developers</li>
                            <li>Designers</li>
                            <li>QA</li>
                            <li>DevOps</li>
                        </ul>
                        <div className="eng-specs">
                            <div className="e-sp1">
                                <p>Duration</p>
                                <strong>Mid - Long</strong>
                            </div>
                            <div className="e-sp1">
                                <p>Flexibility</p>
                                <strong>High</strong>
                            </div>
                            <div className="e-sp1">
                                <p>Engagement model</p>
                                <strong>Scope Based</strong>
                            </div>
                        </div>
                    </div>
                </div>
            </div>


        </section>
    )
}

export default Engagement